import styled from "@emotion/styled";



export const DFNLoginButtonContainer = styled.div`
    display: flex;
    justify-content: center;
    margin-top: 1rem;
`;

export const DFNButton = styled.button`
    background: white;
    border: 1px solid #ccc;
    padding: 10px 20px;
    display: flex;
    align-items: center;
    border-radius: 5px;
    cursor: pointer;
    transition: background 0.2s;

    &:hover {
        background: #f0f0f0;
    }
`;

export const Logo = styled.img`
    width: 3.5em;
    margin-right: 10px;
`;

